import { Box } from "@material-ui/core";
import { useConnect } from "./context/connect";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { Navigation } from "./components/Navigation";
import { CustomTextField } from "./components/CannedResponses/CannedResponsesPopup";
import { Agent } from "./components/Agent";

import { useStyles } from "./style";

export default function App() {
  const classes = useStyles();
  const { loaded, activeTab, agentChatSession } = useConnect();

  return (
    <Box className={classes.App}>
      <ReactNotifications />
      <Box className={classes.wrapper}>
        <Box className={classes.window}>
          <Navigation />
          {activeTab === "chat" && !!agentChatSession && <CustomTextField />}
          <Box id="stream" height={"100%"} className={classes.stream}></Box>
        </Box>
        <Box className={classes.window}>
          <Agent />
        </Box>
        {!loaded && (
          <Box className={classes.splash_screen}>
            <Box>
              <img
                src="/images/black_logo.svg"
                alt="tripshock"
                className={classes.splash_screen_img}
              />
              <Box className={classes.splash_screen_title}>Amazon Connect</Box>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
}
